<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template #activator="{ on }">
      <v-btn v-if="user.active" x-small :class="activatorClass" color="grey lighten-4" v-bind="$attrs" v-on="on">
        Deactivate This User
      </v-btn>
      <v-btn v-else x-small :class="activatorClass" color="grey lighten-4" v-bind="$attrs" v-on="on">
        Reactivate This User
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="d-flex justify-center">Please Confirm</v-card-title>

      <v-divider />

      <v-card-text class="pt-2 text-center">
        {{ message }}
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-center py-4">
        <v-btn @click="close" color="primary">Cancel</v-btn>
        <v-btn v-if="user.active" class="ml-3" color="grey lighten-4" @click="deleteClick">
          Deactivate
        </v-btn>
        <v-btn v-else class="ml-3" color="grey lighten-4" @click="deleteClick">
          Reactivate
        </v-btn>
      </v-card-actions>
    </v-card>
    <ErrorOverlay
      title="Error Removing User"
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </v-dialog>
</template>

<script>
import { required } from '@/lib/validations'
import { mapActions, mapGetters } from 'vuex'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'DeleteDialog',

  mixins: [ ErrorOverlayMixin ],

  inheritAttrs: false,

  props: {
    user: { type: Object, required: true },
    activatorClass: { type: String, default: '' },
  },

  computed: {
    ...mapGetters('auth', ['me']),

    message() {
      if ( this.user.user_id == this.me.user_id)
        return "Are you sure you want to delete your own account?  This can not be undone!"

      if (this.user.active)
        return "Are you sure you want to deativate this user?  If they have no referrals, the user will be deleted.  Otherwise they will be deactivated."
    
      return "Are you sure you want to reactivate this user?"
    }
  },

  data() {
    return {
      dialogVisible: false,

      // validation rules
      required,
    }
  },

  watch: {
    error_dialog(visible) {
      if (!visible)
        this.close()
    }
  },

  methods: {
    ...mapActions('users', ['activateUser', 'deleteUser']),

    close() {
      this.dialogVisible = false
    },

    async deleteClick() {
      this.loading = true

      let result
      if (this.user.active) {
        result = await this.deleteUser( this.user)
      } else {
        result = await this.activateUser( this.user )
      }
      this.loading=false

      if(result.ok) {
        this.close()
        this.$router.replace({ name: 'you/users' })
      } else {
        this.error_dialog = true
        this.error_message = result.error
      }
    }, 
  },
}
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>